export const NEWZEALAND_REGIONS = [
  { name: "Northland", value: "NTL" },
  { name: "Auckland", value: "AUK" },
  { name: "Waikato", value: "WKO" },
  { name: "Bay of Plenty", value: "BOP" },
  { name: "Gisborne", value: "GIS" },
  { name: "Hawke's Bay", value: "HKB" },
  { name: "Taranaki", value: "TKI" },
  { name: "Manawatū-Whanganui", value: "MWT" },
  { name: "Wellington", value: "WGN" },
  { name: "Tasman", value: "TAS" },
  { name: "Nelson", value: "NSN" },
  { name: "Marlborough", value: "MBH" },
  { name: "West Coast", value: "WTC" },
  { name: "Canterbury", value: "CAN" },
  { name: "Otago", value: "OTA" },
  { name: "Southland", value: "STL" },
];
